import { useTheme } from 'styled-components';

type PropsType = {
  overrideStyle?: Record<any, any>;
};

const TwitterIcon = ({ overrideStyle = {} }: PropsType) => {
  const theme = useTheme();
  return (
    <svg viewBox="0 0 53 44" style={{ ...overrideStyle }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.7031 5.87306C50.7733 6.73617 48.6966 7.31743 46.5183 7.57988C48.7421 6.23767 50.4497 4.11338 51.2527 1.58219C49.1742 2.82577 46.8665 3.72587 44.4153 4.21379C42.4505 2.10711 39.6494 0.789551 36.5544 0.789551C30.6076 0.789551 25.7857 5.64407 25.7857 11.6312C25.7857 12.4802 25.8819 13.3081 26.0656 14.1025C17.1147 13.6516 9.18032 9.33428 3.86856 2.77469C2.94128 4.37583 2.41115 6.23769 2.41115 8.22459C2.41115 11.9853 4.30945 15.3038 7.20153 17.2484C5.43444 17.1921 3.77583 16.7041 2.32192 15.8921V16.0277C2.32192 21.2821 6.0363 25.6628 10.9596 26.6615C10.0569 26.9081 9.10508 27.042 8.12356 27.042C7.42898 27.042 6.75363 26.9733 6.09579 26.8465C7.46572 31.1532 11.4443 34.2886 16.1559 34.3766C12.4713 37.283 7.82788 39.018 2.78206 39.018C1.91076 39.018 1.05347 38.9669 0.211914 38.8648C4.9778 41.9402 10.6377 43.7369 16.7193 43.7369C36.5264 43.7369 47.3581 27.2164 47.3581 12.8906C47.3581 12.4203 47.3494 11.9518 47.3267 11.4885C49.4332 9.95608 51.2597 8.04667 52.7031 5.87306Z"
        fill={overrideStyle.color || theme.black}
      />
    </svg>
  );
};

export default TwitterIcon;
